import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Rating, Skeleton } from "@mui/material";
import { SingleProposerInfoType } from "../../lib/proposerAPI";
import ProfileIcon from "../common/profileIcon";
import { Box } from "@mui/material";
import styles from "../../styles/proposer/proposerInfo.module.css";

export const ProposerInfo: React.FC<SingleProposerInfoType> = (props) => {
  const { user_name, quick_stats_data } = props;

  return (
    <Card className={styles.card} elevation={4}>
      <ProfileIcon
        userName={user_name === null ? "Unknown" : user_name.trim()}
        width="60px"
        height="60px"
      />
      <CardContent className={styles.cardContent}>
        <Typography gutterBottom variant="h5" component="div">
          {user_name}
        </Typography>
        <Box className={styles.ratingBox}>
          <Rating
            name="text-feedback"
            value={quick_stats_data.average_rating}
            readOnly
            precision={0.1}
          />
          <Box className={styles.ratingNumBox}>
            {quick_stats_data.average_rating.toFixed(1)}
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary">
          {"Number of proposals: " + quick_stats_data.number_of_proposals}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {"Funded proposals: " + quick_stats_data.funded_proposals}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {"Amount requested: " + quick_stats_data.amount_requested}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {"Amount funded: " + quick_stats_data.funded_amount}
        </Typography>
      </CardContent>
    </Card>
  );
};

export const ProposerInfoLoading = () => {
  return (
    <Card className={styles.card} elevation={4}>
      <Skeleton variant="circular" className={styles.skeletonCircular} />
      <CardContent className={styles.cardContent}>
        <Skeleton variant="rectangular" className={styles.skeletonName} />
        <Skeleton variant="rectangular" className={styles.skeletonRating} />
        <Skeleton variant="text" className={styles.skeletonText} />
        <Skeleton variant="text" className={styles.skeletonText} />
      </CardContent>
    </Card>
  );
};
